(function () {
    'use strict';

    angular
        .module('elogbooks.admin.sitegroups')
        .controller('SiteGroupDetailsController', SiteGroupDetailsController);

    SiteGroupDetailsController.$inject = ['siteGroupResponse'];

    function SiteGroupDetailsController (siteGroupResponse) {
        var vm = this;
            vm.sitegroup = siteGroupResponse;
    }
})();
